import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

interface IRepliedMessagePresenter {
  message: ChatMessage | null;
  title: string;
  setMessage(quote: ChatMessage | null): void;
}

export function useRepliedMessagePresenter(message: ChatMessage | null): IRepliedMessagePresenter {
  const presenter = useLocalObservable<IRepliedMessagePresenter>(() => ({
    message: null,

    get title(): string {
      if (!presenter.message) {
        return '';
      }

      const sourceMessage = message?.group?.messagesStore?.getMessageById(message?.id);

      return sourceMessage?.forward
        ? sourceMessage.forward.avatarTitle
        : message?.avatarTitle || message?.group?.avatarTitle || '';
    },

    setMessage(message: ChatMessage | null): void {
      presenter.message = message;
    },
  }));

  useEffect(() => {
    presenter.setMessage(message);
  }, [message]);

  return presenter;
}
